import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { TopListRequestDateParameters } from '@/models/top-list/top-list-request-date-parameters.model';
import { TopPlayerListResponse } from '@/models/top-list/top-player-list-response.model';
import { TopPlayerListItem } from '@/models/top-list/top-player-list.model';

import { clearObj } from '@marfa/bo-utils';

export default class GetTopPlayerListRequest extends ApiResourceMethod<TopPlayerListResponse> {
  public perform(whitelabelSlug: string, requestPayload: TopListRequestDateParameters): Promise<TopPlayerListResponse> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/report/player`,
        params: clearObj(requestPayload),
      },
      ({ data, headers }: BaseResponse<TopPlayerListItem[]>): TopPlayerListResponse => ({
        data,
        headers,
      }),
    );
  }
}
